import React from 'react';
import { useSelector } from 'react-redux';

import { Layout } from 'common/components/layout';
import { useLocalization } from 'redux/localization/utils/hooks';

const NotFound = () => {
  const setting = useSelector((state) => state.setting.data);
  const { t } = useLocalization();
  return (
    <Layout
      title={t('clubSignup.general.clubNotFoundTitle')}
      description={t('clubSignup.general.clubNotFoundTitle')}
    >
      <section className="c7-content c7-error-page">
        <div className="c7-wrapper">
          <h1 className="c7-h1">{t('clubSignup.general.clubNotFoundTitle')}</h1>
          <p>
            {t('clubSignup.general.clubNotFoundMessage')}{' '}
            <a href={setting.clubList}>
              {t('clubSignup.general.clubNotFoundMessageLink')}
            </a>
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
